import { useContext, useEffect, useRef } from "react";
import { Box, Grid, Stack, Typography, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField} from "@mui/material"
import { ToolContext } from "../../../../../core/context/ToolContext";
import { rqx } from "../../../../../core/request/API";
import { env } from "../../../../../core/Env";
import { SnakeLoader } from "../../../../../core/loader/SnakeLoader";
import { AnotherDetails } from "./AnotherDetails";
import { fieldStyle } from "../../../../../core/global/realproperty/Index";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";

export const MainInformation = ({ handleChange }) => {
    const { realproperty_state } = useContext(ToolContext);
    const { mainInfrmtn, dfltMainInfrmtn, types, loader } = realproperty_state;
    const quillRef = useRef(null);
    const classes = fieldStyle();
    
    const handleDescriptionChange = (value) => {
        const t = document.createElement("div");
        t.innerHTML = value.replace(/(<([^>]+)>)/gi, "");
        const plainText = t.textContent.trim();
        if (plainText.length > 900) {
            quillRef.current.getEditor().root.innerHTML = mainInfrmtn.data.description; 
            return; 
        }

        mainInfrmtn.set({
            ...mainInfrmtn.data,
                description: plainText.length === 0 ? "" : value,
        });
    };
    // to exclude html tags
    const getPlainTextLength = (v) => {
        const t = document.createElement("div");
        t.innerHTML = v.replace(/(<([^>]+)>)/gi, "");
        return t.textContent.length;
    };
    // to auto convert into int the id, bc in forms it reads and convert it into str automatically
    const handleStrToIntChange = async (e) => {
        const { name, value } = e.target;
        mainInfrmtn.set({
            ...mainInfrmtn.data,
                [name]: name === "offerType" || name === "propertyType" || name === "subType" ? {
                    ...mainInfrmtn.data[name],
                    value: value ? parseInt(value) : '',
                    stat: false
                } : value ? parseInt(value) : ''
        });
        if (name === "propertyType" || name === "offerType") {
            loader.set(false);
            if (Number(value)) {
                name === "propertyType" && await readSubTypes(Number(value));
                mainInfrmtn.set((p) => ({
                    ...p,
                    bathroom: "",
                    bedroom: "",
                    blockLotUnitFloorNo: "",
                    buildingName: "",
                    condominiumName: "", 
                    floorArea: "",
                    forClosure: 0,
                    landSize: "",
                    preSelling: 0,
                    showPrice: 0,
                    subdivisionName: "",
                    unitNoFloorNo: "",
                    price: { ...mainInfrmtn.data.price, value: "", stat: false, msg: dfltMainInfrmtn.data.price.msg },
                    monthly: { ...mainInfrmtn.data.monthly, value: "", stat: false, msg: dfltMainInfrmtn.data.monthly.msg },
                    yearly: { ...mainInfrmtn.data.yearly, value: "", stat: false, msg: dfltMainInfrmtn.data.yearly.msg },
                    availableFrom: { ...mainInfrmtn.data.availableFrom, value: "", stat: false, msg: dfltMainInfrmtn.data.availableFrom.msg },
                    ...(name === "propertyType" && { subType: {...mainInfrmtn.data.subType, value: '', stat: true, msg: "Sub-type is required" } }),
                }));
            }
            loader.set(true);
            return;
        }
    }

    const readTypes = async () => {
        if (types.data.propertyTypes.length === 0) {
            const res_property_type = await rqx.get(`<<tool>>/${env()}/propertyListing/initialReader`, { ref: "property_type" });
            if (res_property_type) {
                types.set((p) => ({
                    ...p, propertyTypes: res_property_type
                }))
            }
        }
    };

    const readSubTypes = async (property_id) => {
        const res_property_subtype = await rqx.get(`<<tool>>/${env()}/propertyListing/initialReader`, { ref: "property_subtype", filtered_id: property_id });
        if (res_property_subtype) {
            types.set((p) => ({
                ...p,
                propertySubTypes: res_property_subtype
            }));
        }
    }

    useEffect(() => {
        readTypes();
        readSubTypes(mainInfrmtn.data.propertyType.value)
        // eslint-disable-next-line
    }, [])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography fontWeight={600} fontSize={14}>Listing Title<Typography component="span" color="error">*</Typography></Typography>
                <TextField name="listingTitle" value={mainInfrmtn.data.listingTitle.value} onChange={(e) => handleChange(e, mainInfrmtn)} error={mainInfrmtn.data.listingTitle.stat} helperText={mainInfrmtn.data.listingTitle.stat ? dfltMainInfrmtn.data.listingTitle.msg : ""} size="small" fullWidth sx={{ mt: "0.5rem" }} className={classes.tf}/>
            </Grid>
            <Grid item xs={12}>
                <Typography mb="0.5rem" fontWeight={600} fontSize={14}>
                    Description
                </Typography>
                <Box>
                    <Box sx={{ height: "13.75rem", overflow: "hidden", borderRadius: "12px"}}>
                        <ReactQuill
                            ref={quillRef}
                            value={mainInfrmtn.data.description}
                            onChange={handleDescriptionChange}
                            placeholder="Enter description here..."
                            modules={{
                                toolbar: [
                                    ["bold", "italic"],
                                    [{ list: "ordered" }, { list: "bullet" }],
                                ],
                            }}
                            style={{
                                backgroundColor: "#ffffff",
                                borderRadius: "12px",
                                border: "1px solid rgba(0,0,0,0.2)",
                                height: "100%",
                                paddingBottom: "2.678rem",
                            }}
                        />
                    </Box>
                    <Stack direction="row" justifyContent="right">
                        <Typography component="span">{getPlainTextLength(mainInfrmtn.data.description)}</Typography>
                        <Typography component="span">/900 characters</Typography>
                    </Stack>
                </Box>
            </Grid>
            <Grid item xs={6}>
                <FormControl fullWidth>
                    <FormLabel id="offer-type-group-label" sx={{ fontWeight: "600", fontSize: "14px", color: "#000", "&.Mui-focused": { color: "#000"}, }}>
                        Offer type <Typography component="span" color="error">*</Typography>
                    </FormLabel>
                    <RadioGroup row aria-labelledby="offer-type-group-label" name="offerTypeRadioGroup" value={mainInfrmtn.data.offerType.value} onChange={handleStrToIntChange}>
                        <FormControlLabel name="offerType" value={1} control={<Radio/>} label="Sell" />
                        <FormControlLabel name="offerType" value={2} control={<Radio/>} label="Rent" />
                    </RadioGroup>
                </FormControl>
            </Grid>
            {types.data.propertyTypes.length !== 0 && 
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <FormLabel id="property-type-group-label" sx={{ fontWeight: "600", fontSize: "14px", color: "#000", "&.Mui-focused": { color: "#000"}, }}>
                            Property type <Typography component="span" color="error">*</Typography>
                        </FormLabel>
                        <RadioGroup row aria-labelledby="property-type-group-label" name="propertyTypeRadioGroup" value={mainInfrmtn.data.propertyType.value} onChange={handleStrToIntChange}>
                            {types.data.propertyTypes?.map((v, i) => (
                                <FormControlLabel name="propertyType" key={i} value={v.id} control={<Radio/>} label={v.name} />
                            ))}
                        </RadioGroup>
                    </FormControl>
                </Grid>
            }
            { mainInfrmtn.data.propertyType.value && 
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <FormLabel id="sub-type-group-label" sx={{ fontWeight: "600", fontSize: "14px", color: mainInfrmtn.data.subType.stat ? "red" : "#000", "&.Mui-focused": { color: "#000"}, }}>
                            Sub type <Typography component="span" color="error">*</Typography>
                        </FormLabel>
                        {types.data.propertySubTypes.length === 0 ?
                            <Box py="0.5rem" display="flex" alignItems="center" justifyContent="center">
                                <SnakeLoader bg="#11783C" size="7px" distance="7px"/> 
                            </Box> 
                        :
                            <RadioGroup row aria-labelledby="sub-type-group-label" name="subTypeRadioGroup" value={mainInfrmtn.data.subType.value} onChange={handleStrToIntChange}>
                                {types.data.propertySubTypes?.map((v, i) => (
                                    <FormControlLabel name="subType" key={i} value={v.id} control={<Radio/>} label={v.name} />
                                ))}
                            </RadioGroup>
                        }
                    </FormControl>
                </Grid>
            }
            <AnotherDetails classes={classes} handleChange={handleChange} handleStrToIntChange={handleStrToIntChange}/>
        </Grid>
    )
}
